import { useState } from 'react';

import { Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { EmailOutlined } from '@mui/icons-material';
import { OrgManager, OrgManagerStatus } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { CalendarDateService } from '@uplift/services';
import { UserStatus } from '@uplift/types';
import { Button } from '@uplift/ui-v2';

import { useHigherEdHandlers } from '../hooks';
import { ManagementTableColumnRenderArgs } from '../types';

export type ManagerStatusCellProps = ManagementTableColumnRenderArgs<keyof OrgManager> & {
  row: OrgManager;
};

export const ManagerStatusCell: React.VFC<ManagerStatusCellProps> = ({ row }) => {
  const l10n = useL10n();
  const [ loading, setLoading ] = useState(false);
  const invitedDate = CalendarDateService.date(row?.user?.createdAt).format('MM/DD/YY');
  const isInvited = row?.status === OrgManagerStatus.inactive && row?.user?.status === UserStatus.initial;
  const isDeactivated = row?.status === OrgManagerStatus.inactive && row?.user?.status === UserStatus.regular;
  const { handleResendInvite } = useHigherEdHandlers(row.orgId);

  const resendInvite = async () => {
    setLoading(true);
    await handleResendInvite(row);
    setLoading(false);
  };

  if (isDeactivated) {
    return (
      <Typography variant="body2" color="textPrimary">Deactivated</Typography>
    );
  }

  return (
    <div>
      {isInvited ? (
        <>
          <Typography variant="body2" color="textPrimary">{`Invited ${invitedDate}`}</Typography>
          <StyledResendInviteButton
            startIcon={<EmailOutlined />}
            size="small"
            disabled={loading}
            loading={loading}
            onClick={resendInvite}
          >
            {l10n.admin.inviteProvider.resendInvite}
          </StyledResendInviteButton>
        </>

      ) : (
        <Typography variant="body2" color="textPrimary">Active</Typography>
      )}
    </div>
  );
};

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. Unsupported arrow function syntax.
//Unexpected value type of MemberExpression.
const StyledResendInviteButton = withStyles(Button, (theme) => ({
  root: {
    padding: 0,
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    marginLeft: -theme.spacing(0.5),
    textTransform: 'none',
    color: theme.palette.text.secondary,
    height: '20px'
  },
  label: theme.typography.body2,
  startIcon: {
    fontSize: '18px',
    marginRight: theme.spacing(0.5)
  }
}));
